import LogoHeader from '@/sections/LogoHeader';
import MeetingEndIcon from '@/assets/record/meeting_end.svg?react';

const MobileMeetingEnd = () => {
  return (
    <div className="w-full h-full flex flex-col">
      <LogoHeader />
      <div className="flex flex-col items-center h-full">
        <div className="h-1/3"></div>
        <div className="flex flex-col items-center">
          <MeetingEndIcon className="w-20 h-20" />
          <div className="text-3.5 lh-5 text-center pr-2 pl-2 pb-2 font-400 text-#626773">会议已结束，感谢使用</div>
          <div className="text-3 lh-5 text-center pr-2 pl-2 font-400 text-#A1A7B2">The meeting has concluded, thank you for participating.</div>
        </div>
        <div className="h-2/3"></div>
      </div>
    </div>
  )
}

export default MobileMeetingEnd;